"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleNftKindWrapper = void 0;
/* eslint-disable node/no-extraneous-import */
/* eslint-disable node/no-unsupported-features/node-builtins */
const solana_contrib_1 = require("@saberhq/solana-contrib");
const web3_js_1 = require("@solana/web3.js");
const bn_js_1 = __importDefault(require("bn.js"));
const assert_1 = __importDefault(require("assert"));
const Realm_1 = require("./Realm");
const utf8_1 = require("@project-serum/anchor/dist/cjs/utils/bytes/utf8");
class SimpleNftKindWrapper {
    constructor(sdk, address) {
        this.sdk = sdk;
        this.address = address;
        this._data = null;
        this._realm = null;
    }
    get provider() {
        return this.sdk.provider;
    }
    get program() {
        return this.sdk.program;
    }
    async reload() {
        this._data = await this.program.account.simpleNftKind.fetch(this.address);
        if (!this._realm || !this._realm.address.equals(this._data.realm)) {
            this._realm = new Realm_1.RealmWrapper(this.sdk, this._data.realm);
        }
        return this._data;
    }
    async tryReload() {
        this._data = await this.program.account.simpleNftKind.fetchNullable(this.address);
        if (this._data &&
            (!this._realm || !this._realm.address.equals(this._data.realm))) {
            this._realm = new Realm_1.RealmWrapper(this.sdk, this._data.realm);
        }
        return this._data;
    }
    async data() {
        if (!this._data) {
            return await this.reload();
        }
        return this._data;
    }
    async tryData() {
        if (!this._data) {
            return await this.tryReload();
        }
        return this._data;
    }
    async realm() {
        if (!this._realm) {
            await this.reload();
        }
        return this._realm;
    }
    async governor() {
        return await (await this.realm()).governor();
    }
    async govMint() {
        return (await (await this.realm()).data()).govMint;
    }
    async createAccount({ accountKP, nameTemplate, symbolTemplate, lockedUriTemplate, unlockingUriTemplate, extraSize = 256, rentPayer, }) {
        const signers = [accountKP];
        if (rentPayer) {
            signers.push(rentPayer);
        }
        const space = SimpleNftKindWrapper.SPACE +
            (0, utf8_1.encode)(nameTemplate).length +
            (0, utf8_1.encode)(symbolTemplate).length +
            (0, utf8_1.encode)(lockedUriTemplate).length +
            (0, utf8_1.encode)(unlockingUriTemplate).length +
            extraSize;
        return new solana_contrib_1.TransactionEnvelope(this.provider, [
            web3_js_1.SystemProgram.createAccount({
                fromPubkey: (rentPayer === null || rentPayer === void 0 ? void 0 : rentPayer.publicKey) || this.provider.wallet.publicKey,
                newAccountPubkey: this.address,
                lamports: await this.provider.connection.getMinimumBalanceForRentExemption(space),
                space,
                programId: this.program.programId,
            }),
        ], signers);
    }
    async init({ realm, admin, cooldown, multiplier, minGovAmount, isRelockable = true, nameTemplate, symbolTemplate, lockedUriTemplate, unlockingUriTemplate, mintLimit = new bn_js_1.default('18446744073709551615'), editionIndex = 0, lockedCollection = web3_js_1.PublicKey.default, unlockingCollection = web3_js_1.PublicKey.default, sellerFee = 0, }) {
        if (!admin) {
            admin = (await realm.data()).admin;
        }
        const signers = [];
        if (!(admin instanceof web3_js_1.PublicKey)) {
            signers.push(admin);
            admin = admin.publicKey;
        }
        return new solana_contrib_1.TransactionEnvelope(this.provider, [
            await this.program.methods
                .initSimpleNftKind(cooldown, multiplier, minGovAmount, isRelockable, nameTemplate, symbolTemplate, lockedUriTemplate, unlockingUriTemplate, mintLimit, editionIndex, lockedCollection, unlockingCollection, sellerFee)
                .accounts({
                realm: realm.address,
                govMint: (await realm.data()).govMint,
                admin,
                nftKind: this.address,
            })
                .instruction(),
        ], signers);
    }
    static async create({ address = new web3_js_1.Keypair(), realm, admin, cooldown, multiplier, minGovAmount, isRelockable = true, nameTemplate, symbolTemplate, lockedUriTemplate, unlockingUriTemplate, mintLimit = new bn_js_1.default('18446744073709551615'), editionIndex = 0, lockedCollection = web3_js_1.PublicKey.default, unlockingCollection = web3_js_1.PublicKey.default, sellerFee = 0, rentPayer, }) {
        const wrapper = new SimpleNftKindWrapper(realm.sdk, address.publicKey);
        const tx = (await wrapper.createAccount({
            accountKP: address,
            nameTemplate,
            symbolTemplate,
            lockedUriTemplate,
            unlockingUriTemplate,
            rentPayer,
        })).combine(await wrapper.init({
            realm,
            admin,
            cooldown,
            multiplier,
            minGovAmount,
            isRelockable,
            nameTemplate,
            symbolTemplate,
            lockedUriTemplate,
            unlockingUriTemplate,
            mintLimit,
            editionIndex,
            lockedCollection,
            unlockingCollection,
            sellerFee,
        }));
        return {
            tx,
            wrapper,
        };
    }
    async config({ admin, 
    /*
    cooldown = null,
    multiplier = null,
    minGovAmount = null,
    */
    isDisabled = null, realm, }) {
        if (!admin) {
            admin = (await (await this.realm()).data()).admin;
        }
        const signers = [];
        if (!(admin instanceof web3_js_1.PublicKey)) {
            signers.push(admin);
            admin = admin.publicKey;
        }
        if (!realm) {
            realm = (await this.data()).realm;
        }
        if (!(realm instanceof web3_js_1.PublicKey)) {
            realm = realm.address;
        }
        const tx = new solana_contrib_1.TransactionEnvelope(this.provider, [], signers);
        if (isDisabled !== null) {
            tx.instructions.push(await this.program.methods
                .setDisabled(isDisabled)
                .accounts({
                nftKind: this.address,
                realm,
                admin,
            })
                .instruction());
        }
        return tx;
    }
    async connectRealm(realm) {
        (0, assert_1.default)(realm.sdk === this.sdk);
        const data = await this.data();
        if (!data.realm.equals(realm.address)) {
            throw new Error(`Wrong realm. Expected ${data.realm.toBase58()}`);
        }
        this._realm = realm;
    }
    static async loadAll(sdk, realm) {
        const accounts = await sdk.program.account.simpleNftKind.all(realm ? realm.address.toBuffer() : undefined);
        return accounts.map(account => {
            const ntfKind = new SimpleNftKindWrapper(sdk, account.publicKey);
            ntfKind._realm = realm || null;
            ntfKind._data = account.account;
            return ntfKind;
        });
    }
}
exports.SimpleNftKindWrapper = SimpleNftKindWrapper;
SimpleNftKindWrapper.SPACE = 164 + 8 * 32;
//# sourceMappingURL=SimpleNftKind.js.map